import {
  Alignment, Bold, Code, Essentials, Font, FontColor, FontSize, Heading,
  Indent, IndentBlock, Italic, Link, List, Paragraph,
  RemoveFormat, Strikethrough, TodoList, Underline
} from "ckeditor5"

export const ckEditorConfig = {
  licenseKey: "GPL",
  plugins: [
    Heading,
    Essentials,
    Paragraph,
    Bold, Italic, Underline, Strikethrough, Code,
    FontSize, Font, FontColor, RemoveFormat,
    Alignment,
    List, TodoList,
    Indent, IndentBlock,
    Link,
  ],
  toolbar: [
    "heading", "|",
    "undo", "redo", "|",
    "bold", "italic", "underline", "strikethrough", "code", "|",
    "fontSize", "fontFamily", "fontColor", "fontBackgroundColor", "removeFormat", "|",
    "alignment:left", "alignment:right", "alignment:center", "alignment:justify", "|",
    "bulletedList", "numberedList", "todoList", "|",
    "indent", "outdent", "|",
    "link",
    // "|",
  ],
  initialData: "",
  fontSize: {
    options: [14, 16, 20, 24, 32, 36,]
  },
  fontFamily: {
    options: [
      "default",
      "Poppins",
      "Ubuntu, Arial, sans-serif",
      "Ubuntu Mono, Courier New, Courier, monospace",
    ]
    // supportAllValues: true
  },
  fontColor: {
    colorPicker: {
      format: "hex"
    }
  },
  heading: {
    options: [
      { model: "heading1", view: "h1", title: "Heading 1", class: "ck-heading_heading1" },
      { model: "heading2", view: "h2", title: "Heading 2", class: "ck-heading_heading2" },
      { model: "heading3", view: "h3", title: "Heading 3", class: "ck-heading_heading3" },
      { model: "heading4", view: "h4", title: "Heading 4", class: "ck-heading_heading4" },
      { model: "heading5", view: "h5", title: "Heading 5", class: "ck-heading_heading5" },
      { model: "heading6", view: "h6", title: "Heading 6", class: "ck-heading_heading6" },
      { model: "paragraph", title: "Paragraph", class: "ck-heading_paragraph" },
    ]
  },
}